import { RootStore } from '../rootStore';
import { FormikHelpers } from 'formik';
import { FormStore } from 'stores/formStore';

import { ADMIN_NOTIFICATIONS, ADMIN_NOTIFICATIONS_DELETE } from 'api/endpoints';
import { observable, action } from 'mobx';
import { MessageData } from 'components/Layout/Notification';
import { SingleValueResponse } from 'common/interfaces';

export class BackofficeNotificationsStore extends FormStore<MessageData> {
  rootStore: RootStore;
  @observable notifications: MessageData[] | null;
  @observable editOpen = false;

  constructor(rootStore: RootStore) {
    super(rootStore);
    this.rootStore = rootStore;
    this.notifications = null;
  }

  @action setEditOpen = (open: boolean) => (this.editOpen = open);

  fetchNotifications = async () => {
    const response = await this.rootStore.stores.apiStore.get<MessageData[]>(ADMIN_NOTIFICATIONS);
    if (response?.data) {
      this.notifications = response.data;
    }
  };

  @action
  handleSubmit = async (values: MessageData, formikHelpers?: FormikHelpers<MessageData>) => {
    this.rootStore.stores.uiStore.setLoading(true);
    if (values.id === '') {
      delete values['id'];
    }
    const success = await this.submitData(ADMIN_NOTIFICATIONS, values, {
      validationPrefixDepth: 2,
      formikHelpers,
      reset: false,
      singleValueResponse: true,
    });
    this.rootStore.stores.uiStore.setLoading(false);
    if (success) {
      this.setEditOpen(false);
      this.notifications = null;
      await this.fetchNotifications();
    }
  };

  @action
  deleteNotification = async (id: string) => {
    this.rootStore.stores.uiStore.setLoading(true);
    const response = await this.rootStore.stores.apiStore.delete<SingleValueResponse<boolean>>(
      ADMIN_NOTIFICATIONS_DELETE(id),
    );
    if (response?.data?.value) {
      this.notifications = null;
      await this.fetchNotifications();
    }
    this.rootStore.stores.uiStore.setLoading(false);
  };
}
